import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const [showSuccess, setShowSuccess] = useState(false);
    const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    datetime: '',
    tour: '1',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Show success message instead of actual submission
    setShowSuccess(true);
    
    // Optional: Clear form after 3 seconds
    setTimeout(() => {
      setShowSuccess(false);
      setFormData({
        name: '',
        email: '',
        datetime: '',
        tour: '1',
        message: ''
      });
    }, 5000);
  };
  return (
    <div>
      {/* Hero Header - Sky & Gold Theme */}
    <div
  className="container-fluid py-5 mb-5 hero-header position-relative"
  style={{
    background: 'linear-gradient(135deg, rgba(11, 19, 32, 0.85) 0%, rgba(28, 62, 85, 0.85) 100%), url("https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1396&q=80")',
    backgroundSize: 'cover',
    backgroundPosition: 'center 30%',
    backgroundRepeat: 'no-repeat'
  }}
>
  <div className="container py-5">
    <div className="row justify-content-center py-5">
      <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
        <h1 className="display-3 text-white mb-3 animated slideInDown">
          Esplora l'Italia Con Noi
        </h1>
        <p
          className="fs-4 text-white mb-4 animated slideInDown"
          style={{ color: "#E0E0E0" }}
        >
          Discover Rome, Florence, and the hidden gems of Italy with our
          expert audio guides and curated tours.
        </p>
        <div className="position-relative w-75 mx-auto animated slideInDown">
          <input
            className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5"
            type="text"
            placeholder="Cerca una destinazione: Roma, Firenze, Venezia..."
            style={{ backgroundColor: "white", color: "#0B1320" }}
          />
          <button
            type="button"
            className="btn rounded-pill py-2 px-4 position-absolute top-0 end-0 me-2"
            style={{
              marginTop: 7,
              backgroundColor: "#D4AF37",
              borderColor: "#D4AF37",
              color: "#0B1320",
              fontWeight: "bold",
            }}
          >
            Cerca
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
      {/* About Start - Via Italia Story */}
      <div
        className="container-xxl py-5"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="position-relative h-100 rounded overflow-hidden shadow">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1396&q=80"
                  alt="Via Italia Tours - Italian Landscape"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6
                className="section-title bg-white text-start pe-3"
                style={{ color: "#D4AF37", fontWeight: "700" }}
              >
                La Nostra Storia
              </h6>
              <h1 className="mb-4" style={{ color: "#0B1320" }}>
                Welcome to <span style={{ color: "#D4AF37" }}>Via Italia</span>{" "}
                Tours
              </h1>
              <p className="mb-4" style={{ color: "#333333" }}>
                Via Italia Tours brings you the very best of Italy. From the
                ancient wonders of Rome to the Renaissance masterpieces of
                Florence, we craft authentic Italian experiences that go beyond
                the typical tourist path.
              </p>
              <p className="mb-4" style={{ color: "#333333" }}>
                Our passion for Italy's rich culture, history, and cuisine
                drives us to create unforgettable journeys. With our exclusive
                audio guides, you'll explore iconic landmarks and hidden corners
                at your own pace, hearing stories that breathe life into every
                stone and street.
              </p>
              <div className="row gy-2 gx-4 mb-4">
                {[
                  "Audio Guide Tours",
                  "Colosseum & Forum",
                  "Uffizi Gallery Tours",
                  "Wine Tasting in Tuscany",
                  "Vatican City Experiences",
                  "24/7 Italian Support",
                ].map((feature, idx) => (
                  <div className="col-sm-6" key={idx}>
                    <p className="mb-0" style={{ color: "#0B1320" }}>
                      <i
                        className="fa fa-check-circle me-2"
                        style={{ color: "#D4AF37" }}
                      ></i>
                      {feature}
                    </p>
                  </div>
                ))}
              </div>
              <a
                className="btn py-3 px-5 mt-2 rounded-pill"
                href="#"
                style={{
                  backgroundColor: "#0B1320",
                  color: "#D4AF37",
                  fontWeight: "bold",
                  border: "1px solid #D4AF37",
                }}
              >
                Discover Our Tours
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}

      {/* Service Start - Italian Experiences */}
      <div
        className="container-xxl py-5"
        style={{ backgroundColor: "#F8F9FA" }}
      >
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6
              className="section-title bg-white text-center px-3"
              style={{ color: "#D4AF37", fontWeight: "700" }}
            >
              I Nostri Servizi
            </h6>
            <h1 className="mb-5" style={{ color: "#0B1320" }}>
              Authentic Italian Experiences
            </h1>
          </div>
          <div className="row g-4">
            {[
              {
                icon: "fa-headphones",
                title: "Audio Guide Tours",
                desc: "Discover Rome and Florence with our immersive audio guides, available in multiple languages.",
              },
              {
                icon: "fa-landmark",
                title: "Historical Site Tours",
                desc: "Skip-the-line access and expert-led tours to the Colosseum, Roman Forum, and Pantheon.",
              },
              {
                icon: "fa-wine-bottle",
                title: "Food & Wine Tours",
                desc: "Taste authentic Tuscan wines, fresh pasta, and gelato on our culinary adventures.",
              },
              {
                icon: "fa-church",
                title: "Vatican & Religious Tours",
                desc: "Explore St. Peter's, the Sistine Chapel, and the Vatican Museums with expert guides.",
              },
            ].map((service, idx) => (
              <div
                className="col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-delay={`${0.1 + idx * 0.2}s`}
                key={idx}
              >
                <div className="service-item rounded pt-3 shadow-sm bg-white h-100">
                  <div className="p-4 text-center">
                    <i
                      className={`fa fa-3x ${service.icon} mb-4`}
                      style={{ color: "#D4AF37" }}
                    ></i>
                    <h5 style={{ color: "#0B1320" }}>{service.title}</h5>
                    <p style={{ color: "#555555" }}>{service.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Service End */}

      {/* Destination Start - Italy Only */}
      <div
        className="container-xxl py-5"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6
              className="section-title bg-white text-center px-3"
              style={{ color: "#D4AF37", fontWeight: "700" }}
            >
              Destinazioni
            </h6>
            <h1 className="mb-5" style={{ color: "#0B1320" }}>
              Amazing Italian Destinations
            </h1>
          </div>
          <div className="row g-3">
            <div className="col-lg-7 col-md-6">
              <div className="row g-3">
                <div
                  className="col-lg-12 col-md-12 wow zoomIn"
                  data-wow-delay="0.1s"
                >
                  <a
                    className="position-relative d-block overflow-hidden rounded shadow"
                    href=""
                  >
                    <img
                      className="img-fluid w-100"
                      src="https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1396&q=80"
                      alt="Rome"
                      style={{ height: "300px", objectFit: "cover" }}
                    />
                    <div
                      className="fw-bold position-absolute top-0 start-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#D4AF37", color: "#0B1320" }}
                    >
                      Misto Roma
                    </div>
                    <div
                      className="fw-bold position-absolute bottom-0 end-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#0B1320", color: "#D4AF37" }}
                    >
                      Rome
                    </div>
                  </a>
                </div>
                <div
                  className="col-lg-6 col-md-12 wow zoomIn"
                  data-wow-delay="0.3s"
                >
                  <a
                    className="position-relative d-block overflow-hidden rounded shadow"
                    href=""
                  >
                    <img
                      className="img-fluid w-100"
                      src="https://images.unsplash.com/photo-1476362174823-3a23f4aa6d76?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      alt="Florence"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div
                      className="fw-bold position-absolute top-0 start-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#D4AF37", color: "#0B1320" }}
                    >
                      Offerta
                    </div>
                    <div
                      className="fw-bold position-absolute bottom-0 end-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#0B1320", color: "#D4AF37" }}
                    >
                      Florence
                    </div>
                  </a>
                </div>
                <div
                  className="col-lg-6 col-md-12 wow zoomIn"
                  data-wow-delay="0.5s"
                >
                  <a
                    className="position-relative d-block overflow-hidden rounded shadow"
                    href=""
                  >
                    <img
                      className="img-fluid w-100"
                      src="https://images.unsplash.com/photo-1519112232436-9923c6ba3d26?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      alt="Venice"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div
                      className="fw-bold position-absolute top-0 start-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#D4AF37", color: "#0B1320" }}
                    >
                      Novità
                    </div>
                    <div
                      className="fw-bold position-absolute bottom-0 end-0 m-3 py-2 px-3 rounded"
                      style={{ backgroundColor: "#0B1320", color: "#D4AF37" }}
                    >
                      Venice
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-5 col-md-6 wow zoomIn"
              data-wow-delay="0.7s"
              style={{ minHeight: 350 }}
            >
              <a
                className="position-relative d-block h-100 overflow-hidden rounded shadow"
                href=""
              >
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80"
                  alt="Tuscany"
                  style={{ objectFit: "cover" }}
                />
                <div
                  className="fw-bold position-absolute top-0 start-0 m-3 py-2 px-3 rounded"
                  style={{ backgroundColor: "#D4AF37", color: "#0B1320" }}
                >
                  Escursione
                </div>
                <div
                  className="fw-bold position-absolute bottom-0 end-0 m-3 py-2 px-3 rounded"
                  style={{ backgroundColor: "#0B1320", color: "#D4AF37" }}
                >
                  Tuscany
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Destination End */}

      {/* Package Start - Italian Tours */}
      <div
        className="container-xxl py-5"
        style={{ backgroundColor: "#F8F9FA" }}
      >
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6
              className="section-title bg-white text-center px-3"
              style={{ color: "#D4AF37", fontWeight: "700" }}
            >
              Pacchetti
            </h6>
            <h1 className="mb-5" style={{ color: "#0B1320" }}>
              Our Best Italian Packages
            </h1>
          </div>
          <div className="row g-4 justify-content-center">
            {[
              {
                city: "Rome",
                days: 3,
                price: "€299",
                desc: "Explore ancient Rome with our audio guide, including Colosseum, Roman Forum, and Pantheon access. Plus a pasta-making class!",
                img: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1396&q=80",
              },
              {
                city: "Florence",
                days: 2,
                price: "€249",
                desc: "Renaissance art tour with audio guide to Uffizi Gallery and Accademia (David). Includes a leather workshop visit.",
                img: "https://images.unsplash.com/photo-1601195576601-346d58e024c0?q=80&w=1197&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
              },
              {
                city: "Rome + Florence",
                days: 5,
                price: "€499",
                desc: "Best of both cities! Includes high-speed train between Rome and Florence, audio guides for all major sites, and a wine tasting in Chianti.",
                img: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
              },
            ].map((pkg, idx) => (
              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + idx * 0.2}s`}
                key={idx}
              >
                <div className="package-item bg-white rounded shadow overflow-hidden h-100">
                  <div className="overflow-hidden" style={{ height: "200px" }}>
                    <img
                      className="img-fluid w-100 h-100"
                      src={pkg.img}
                      alt={pkg.city}
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div
                    className="d-flex border-bottom"
                    style={{ borderColor: "#D4AF37 !important" }}
                  >
                    <small
                      className="flex-fill text-center border-end py-2"
                      style={{ borderColor: "#D4AF37", color: "#0B1320" }}
                    >
                      <i
                        className="fa fa-map-marker-alt me-2"
                        style={{ color: "#D4AF37" }}
                      ></i>
                      {pkg.city}
                    </small>
                    <small
                      className="flex-fill text-center border-end py-2"
                      style={{ borderColor: "#D4AF37", color: "#0B1320" }}
                    >
                      <i
                        className="fa fa-calendar-alt me-2"
                        style={{ color: "#D4AF37" }}
                      ></i>
                      {pkg.days} days
                    </small>
                    <small
                      className="flex-fill text-center py-2"
                      style={{ color: "#0B1320" }}
                    >
                      <i
                        className="fa fa-user me-2"
                        style={{ color: "#D4AF37" }}
                      ></i>
                      2 Person
                    </small>
                  </div>
                  <div className="text-center p-4">
                    <h3 className="mb-0" style={{ color: "#D4AF37" }}>
                      {pkg.price}
                    </h3>
                    <div className="mb-3 mt-2">
                      {[...Array(5)].map((_, i) => (
                        <small
                          key={i}
                          className="fa fa-star"
                          style={{ color: "#D4AF37" }}
                        ></small>
                      ))}
                    </div>
                    <p style={{ color: "#555555" }}>{pkg.desc}</p>
                    <div className="d-flex justify-content-center mb-2">
                      <a
                        href="#"
                        className="btn btn-sm px-3 border-end rounded-pill me-2"
                        style={{
                          backgroundColor: "#0B1320",
                          color: "#D4AF37",
                          border: "1px solid #D4AF37",
                        }}
                      >
                        Read More
                      </a>
                      <button
                      disabled
                        className="btn btn-sm px-3 rounded-pill"
                        style={{
                          backgroundColor: "#D4AF37",
                          color: "#0B1320",
                          fontWeight: "bold",
                        }}
                      >
                        Sold out
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Package End */}

      {/* Booking Start */}
         <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div
          className="p-5 rounded shadow"
          style={{ backgroundColor: "#0B1320" }}
        >
          <div className="row g-5 align-items-center">
            <div className="col-md-6 text-white">
              <h6
                className="text-white-50 text-uppercase"
                style={{ color: "#D4AF37 !important", letterSpacing: "1px" }}
              >
                Prenotazione
              </h6>
              <h1 className="text-white mb-4" style={{ color: "#FFFFFF" }}>
                Book Your Italian Adventure
              </h1>
              <p className="mb-4" style={{ color: "#E0E0E0" }}>
                Ready to explore Italy? Secure your spot on our guided tours
                or purchase our audio guides to explore at your own pace. Our
                team is here to help you create the perfect Italian itinerary.
              </p>
              <p className="mb-4" style={{ color: "#E0E0E0" }}>
                From the Colosseum to the Uffizi, from Tuscan hills to Roman
                piazzas — let Via Italia Tours be your trusted companion. We
                offer flexible booking and free cancellation up to 24 hours
                before your tour.
              </p>
              <button
                className="btn py-3 px-5 mt-2 rounded-pill"
                onClick={() => navigate("/Contact")}
                style={{
                  backgroundColor: "#D4AF37",
                  color: "#0B1320",
                  fontWeight: "bold",
                }}
              >
                Contact Us
              </button>
            </div>
            <div className="col-md-6">
              <h1 className="text-white mb-4" style={{ color: "#D4AF37" }}>
                Book A Tour
              </h1>
              
              {/* Success Message */}
              {showSuccess && (
                <div 
                  className="alert alert-success rounded-pill mb-4 animate__animated animate__fadeIn"
                  style={{ 
                    backgroundColor: '#D4AF37', 
                    color: '#0B1320',
                    border: 'none',
                    fontWeight: 'bold'
                  }}
                >
                  <i className="fa fa-check-circle me-2"></i>
                  Your query has been forwarded! Our team will contact you within 24 hours. Grazie!
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-transparent text-white"
                        id="name"
                        placeholder="Your Name"
                        style={{ borderColor: "#D4AF37" }}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name" style={{ color: "#D4AF37" }}>
                        Your Name
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control bg-transparent text-white"
                        id="email"
                        placeholder="Your Email"
                        style={{ borderColor: "#D4AF37" }}
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email" style={{ color: "#D4AF37" }}>
                        Your Email
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className="form-floating date"
                      id="date3"
                      data-target-input="nearest"
                    >
                      <input
                        type="date"
                        className="form-control bg-transparent text-white"
                        id="datetime"
                        placeholder="Date"
                        style={{ borderColor: "#D4AF37" }}
                        value={formData.datetime}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="datetime" style={{ color: "#D4AF37" }}>
                        Select Date
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <select
                        className="form-select bg-transparent text-white"
                        id="tour"
                        style={{ borderColor: "#D4AF37" }}
                        value={formData.tour}
                        onChange={handleChange}
                        required
                      >
                        <option
                          value="1"
                          style={{ backgroundColor: "#0B1320" }}
                        >
                          Rome: Colosseum & Forum
                        </option>
                        <option
                          value="2"
                          style={{ backgroundColor: "#0B1320" }}
                        >
                          Florence: Uffizi & Accademia
                        </option>
                        <option
                          value="3"
                          style={{ backgroundColor: "#0B1320" }}
                        >
                          Venice: St. Mark's & Gondola
                        </option>
                        <option
                          value="4"
                          style={{ backgroundColor: "#0B1320" }}
                        >
                          Tuscany: Wine Tour from Florence
                        </option>
                      </select>
                      <label htmlFor="tour" style={{ color: "#D4AF37" }}>
                        Choose Your Tour
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control bg-transparent text-white"
                        placeholder="Special Request"
                        id="message"
                        style={{ height: 100, borderColor: "#D4AF37" }}
                        value={formData.message}
                        onChange={handleChange}
                      />
                      <label htmlFor="message" style={{ color: "#D4AF37" }}>
                        Special Request (dietary needs, etc.)
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn w-100 py-3 rounded-pill"
                      type="submit"
                      style={{
                        backgroundColor: "#D4AF37",
                        color: "#0B1320",
                        fontWeight: "bold",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#87CEEB";
                        e.currentTarget.style.color = "#0B1320";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#D4AF37";
                        e.currentTarget.style.color = "#0B1320";
                      }}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
      {/* Booking End */}

      {/* Process Start - Italian Steps */}
      <div
        className="container-xxl py-5"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="container">
          <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
            <h6
              className="section-title bg-white text-center px-3"
              style={{ color: "#D4AF37", fontWeight: "700" }}
            >
              Processo
            </h6>
            <h1 className="mb-5" style={{ color: "#0B1320" }}>
              3 Easy Steps to La Dolce Vita
            </h1>
          </div>
          <div className="row gy-5 gx-4 justify-content-center">
            {[
              {
                icon: "fa-map-marked-alt",
                title: "Choose Your Destination",
                desc: "Select from our curated tours in Rome, Florence, Venice, or Tuscany. Each destination offers unique audio-guided experiences.",
              },
              {
                icon: "fa-credit-card",
                title: "Book & Pay Securely",
                desc: "Secure your spot with our easy online booking. Instant confirmation and free cancellation up to 24 hours before.",
              },
              {
                icon: "fa-headphones",
                title: "Explore with Audio Guide",
                desc: "Download our app or pick up your device and start exploring Italy's treasures at your own pace.",
              },
            ].map((step, idx) => (
              <div
                className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
                data-wow-delay={`${0.1 + idx * 0.2}s`}
                key={idx}
              >
                <div
                  className="position-relative border pt-5 pb-4 px-4 rounded shadow-sm h-100"
                  style={{ borderColor: "#D4AF37", backgroundColor: "#FFFFFF" }}
                >
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                    style={{
                      width: 100,
                      height: 100,
                      backgroundColor: "#D4AF37",
                    }}
                  >
                    <i
                      className={`fa ${step.icon} fa-3x`}
                      style={{ color: "#0B1320" }}
                    ></i>
                  </div>
                  <h5 className="mt-4" style={{ color: "#0B1320" }}>
                    {step.title}
                  </h5>
                  <hr
                    className="w-25 mx-auto mb-1"
                    style={{ backgroundColor: "#D4AF37", height: "2px" }}
                  />
                  <hr
                    className="w-50 mx-auto mt-0"
                    style={{ backgroundColor: "#D4AF37", height: "1px" }}
                  />
                  <p className="mb-0" style={{ color: "#555555" }}>
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Process End */}

      {/* Testimonial Start */}
      <div
        className="container-xxl py-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div className="container">
          <div className="text-center">
            <h6
              className="section-title bg-white text-center px-3"
              style={{ color: "#D4AF37", fontWeight: "700" }}
            >
              Testimonianze
            </h6>
            <h1 className="mb-5" style={{ color: "#0B1320" }}>
              What Our Travelers Say
            </h1>
          </div>
          <div className="row g-4">
            {[
              {
                name: "Michael from New York",
                tour: "Rome Tour",
                text: "The audio guide was incredible! We explored the Colosseum at our own pace and learned so much. Grazie Via Italia!",
                img: "https://randomuser.me/api/portraits/men/32.jpg",
              },
              {
                name: "Emma from London",
                tour: "Florence & Tuscany",
                text: "Our guide Sophia was so knowledgeable about Renaissance art. The wine tour in Chianti was the highlight of our trip!",
                img: "https://randomuser.me/api/portraits/women/68.jpg",
              },
              {
                name: "David from Sydney",
                tour: "Rome Combo",
                text: "Seamless booking and great customer service. The audio guides made history come alive. Will book again!",
                img: "https://randomuser.me/api/portraits/men/45.jpg",
              },
              {
                name: "Lisa from Toronto",
                tour: "Vatican Tour",
                text: "Giulia was fantastic! She made the Vatican museums and Sistine Chapel accessible and fascinating. Highly recommend.",
                img: "https://randomuser.me/api/portraits/women/22.jpg",
              },
            ].map((test, idx) => (
              <div
                className="col-lg-3 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 + idx * 0.2}s`}
                key={idx}
              >
                <div
                  className="testimonial-item bg-white text-center border rounded p-4 h-100 shadow-sm"
                  style={{ borderColor: "#D4AF37" }}
                >
                  <img
                    className="rounded-circle shadow p-1 mx-auto mb-3"
                    src={test.img}
                    style={{ width: 80, height: 80, objectFit: "cover" }}
                    alt={test.name}
                  />
                  <h5 className="mb-0" style={{ color: "#0B1320" }}>
                    {test.name}
                  </h5>
                  <p style={{ color: "#D4AF37" }}>{test.tour}</p>
                  <p className="mb-0" style={{ color: "#555555" }}>
                    "{test.text}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Testimonial End */}
    </div>
  );
}
